import FlexContainer from './FlexContainer';
import TransactionTable from './TransactionTable';
import TransactionI from '../interfaces/Transaction';
import editTransactionGuest from '../functions/editTransactionGuest';
import axios from 'axios';
import { MouseEvent, useContext, useEffect, useState } from 'react';
import getTransaction from '../functions/getTransaction';
import TransactionsI from '../interfaces/Transactions';
import { useHistory } from 'react-router-dom';
import GlobalContext from '../contexts/GlobalContext';
import Action from '../interfaces/Action';
import TransactionModal from './modals/TransactionModal';
import Button from './Button';
import { WeeklyPointState } from '../interfaces/TransactionTable';

const Transactions = ({
    transactions,
    transaction,
    date,
    setTransaction,
    setLoading,
    setAction,
}: {
    transactions: TransactionsI | null;
    transaction: TransactionI | null;
    date: string;
    setTransaction: (transaction: TransactionI) => void;
    setLoading: (value: boolean) => void;
    setAction: (action: Action) => void;
}) => {
    const { setGuest } = useContext(GlobalContext);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const history = useHistory();
    // Live weekly-point state for every All Access guest in the
    // loyalty week containing `date`. The Points column reads this
    // map first; if it isn't loaded yet, the table falls back to the
    // stored `tx.points` snapshot. One request per page load — the
    // endpoint returns all guests for the week in a single payload.
    const [livePoints, setLivePoints] = useState<
        Record<string, WeeklyPointState>
    >({});
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const { data } = await axios.get<{
                    states: Record<string, WeeklyPointState>;
                }>(`/api/pink-fee/weekly-points`, { params: { date } });
                if (cancelled) return;
                setLivePoints(data?.states || {});
            } catch (e: any) {
                // Non-fatal — the table falls back to the stored
                // snapshot if the live fetch fails.
                // eslint-disable-next-line no-console
                console.warn(
                    '[WEEKLY POINTS] live fetch failed:',
                    e?.message || e,
                );
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [date]);

    const handleEdit = async (e: any) => {
        if (!transactions) {
            return;
        }

        const transactionAllAccess = transactions.allAccess.find(
            (transaction: TransactionI) =>
                transaction._id === e.target.parentElement.id
        );
        const transactionLimited = transactions.limited.find(
            (transaction: TransactionI) =>
                transaction._id === e.target.parentElement.id
        );

        const transaction =
            transactionAllAccess !== undefined
                ? transactionAllAccess
                : transactionLimited;

        await editTransactionGuest(
            transaction as TransactionI,
            setGuest,
            history
        );
    };

    const handleEditTransaction = (e: MouseEvent<HTMLButtonElement>) => {
        const transaction = getTransaction(
            e.currentTarget.children[0].className,
            transactions as TransactionsI
        );

        setTransaction(transaction as TransactionI);
        setAction({ status: true, type: 'edit' });
    };

    const openModal = (e: MouseEvent<HTMLButtonElement>) => {
        const transaction = getTransaction(
            e.currentTarget.children[0].className,
            transactions as TransactionsI
        );

        setTransaction(transaction as TransactionI);
        setIsOpen(true);
    };

    return (
        <FlexContainer>
            <h3 className="transaction-container__text">
                Date selected for look up:{' '}
                <span className="red-span">{date}</span>
            </h3>
            {transactions !== null && (
                <>
                    <TransactionTable
                        transactions={transactions.allAccess}
                        handleEdit={handleEdit}
                        handleEditTransaction={handleEditTransaction}
                        openModal={openModal}
                        allAccess={true}
                        livePoints={livePoints}
                    />
                    <TransactionTable
                        transactions={transactions.limited}
                        handleEdit={handleEdit}
                        handleEditTransaction={handleEditTransaction}
                        openModal={openModal}
                        allAccess={false}
                    />
                </>
            )}
            <Button
                color={'green'}
                margin={true}
                onClick={() =>
                    setAction({
                        status: true,
                        type: 'statistics',
                    })
                }
            >
                Statistics
            </Button>
            <Button
                color={'red'}
                margin={true}
                onClick={() => history.push('/transactions')}
            >
                Go back
            </Button>
            <TransactionModal
                transaction={transaction}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                setLoading={setLoading}
                setAction={setAction}
            />
        </FlexContainer>
    );
};

export default Transactions;
